module.exports = __webpack_public_path__ + "img/Services_connecting2.d0cad52f.png";